import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LinhaService } from '../../providers/linha.service';

@Component({
  selector: 'app-busca-pacote',
  templateUrl: './busca-pacotes.component.html',
  styleUrls: ['./busca-pacotes.component.scss']
})
export class BuscaPacotesComponent  implements OnInit{

  @Input() list = [];
  selected = 1;
  linhaSelected = new Object();

  constructor(
    private router: Router,
    private linha: LinhaService
  ) {}


  changeLinha(linha) {
    this.loadingLinha();
  }

  ngOnInit() {
    this.loadingLinha();
  }

  loadingLinha() {
    this.linha.getLinhaById(this.selected).
    subscribe(data => {
      this.linhaSelected = data;
    });
  }

}
